module.exports = __webpack_public_path__ + "files/551d11c945bbc3c105323e4eba005696.png";